import React, { useState, useEffect } from "react";
import { PhoneOff, Mic, MicOff, Volume2, VolumeX } from "lucide-react";

const Calling = ({ handymanName, handymanAvatar, onHangUp }) => {
  const [isMuted, setIsMuted] = useState(false);
  const [isSpeakerOn, setIsSpeakerOn] = useState(true);
  const [callDuration, setCallDuration] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCallDuration((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const handleHangUp = () => {
    onHangUp?.();
  };

  return (
    <div className="absolute inset-0 z-[10000] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950 rounded-2xl flex items-center justify-center">
      <div className="text-center px-4 py-4 w-full h-full flex flex-col justify-center">
        {/* Handyman Avatar */}
        <div className="relative mb-4">
          <div className="h-20 w-20 rounded-full bg-gradient-to-br from-[#EFA938] to-orange-400 flex items-center justify-center text-white text-2xl font-bold mx-auto shadow-xl">
            {handymanAvatar ? (
              <img src={handymanAvatar} alt={handymanName} className="h-full w-full rounded-full object-cover" />
            ) : (
              handymanName.charAt(0).toUpperCase()
            )}
          </div>
          <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 h-3 w-3 rounded-full bg-green-500 border-2 border-gray-900 dark:border-slate-950 animate-pulse"></div>
        </div>

        {/* Handyman Name */}
        <h2 className="text-lg font-bold text-white dark:text-gray-100 mb-1">{handymanName}</h2>
        <p className="text-gray-300 dark:text-gray-400 text-xs mb-1">Ongoing Call</p>
        <p className="text-gray-400 dark:text-gray-500 text-xs">{formatDuration(callDuration)}</p>

        {/* Call Controls */}
        <div className="flex items-center justify-center gap-3 mt-6">
          {/* Mute/Unmute */}
          <button
            onClick={() => setIsMuted(!isMuted)}
            className={`h-12 w-12 rounded-full flex items-center justify-center transition-all ${
              isMuted
                ? "bg-red-500 hover:bg-red-600 text-white"
                : "bg-white/20 hover:bg-white/30 text-white backdrop-blur-sm"
            }`}
            title={isMuted ? "Unmute" : "Mute"}
          >
            {isMuted ? <MicOff className="h-5 w-5" /> : <Mic className="h-5 w-5" />}
          </button>

          {/* Speaker On/Off */}
          <button
            onClick={() => setIsSpeakerOn(!isSpeakerOn)}
            className={`h-12 w-12 rounded-full flex items-center justify-center transition-all ${
              isSpeakerOn
                ? "bg-[#EFA938] hover:bg-[#d78c1f] text-white"
                : "bg-white/20 hover:bg-white/30 text-white backdrop-blur-sm"
            }`}
            title={isSpeakerOn ? "Turn off speaker" : "Turn on speaker"}
          >
            {isSpeakerOn ? <Volume2 className="h-5 w-5" /> : <VolumeX className="h-5 w-5" />}
          </button>

          {/* Hang Up */}
          <button
            onClick={handleHangUp}
            className="h-12 w-12 rounded-full bg-red-500 hover:bg-red-600 text-white flex items-center justify-center transition-all transform hover:scale-110"
            title="Hang up"
          >
            <PhoneOff className="h-5 w-5" />
          </button>
        </div>

        {/* Status Messages */}
        <div className="mt-4 space-y-1">
          {isMuted && (
            <p className="text-yellow-400 dark:text-yellow-500 text-xs">Microphone is muted</p>
          )}
          {!isSpeakerOn && (
            <p className="text-yellow-400 dark:text-yellow-500 text-xs">Speaker is off</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Calling;

